'use client';
import {createContext, useContext} from "react";
import {Theme} from "@web-libs/features/branding/theme/domain/theme.types";

export const ThemeContext = createContext<Theme|null>(null)

export const useTheme = () => {
    const theme =  useContext(ThemeContext)

    if(theme === null) throw new Error('Theme is not provided!')

    const getPrimary = () => theme.primary!
    const getOnPrimary = () => theme.onPrimary!
    const getWarn = () => theme.warn!
    const getOnWarn = () => theme.onWarn!

    return {
        getPrimary,
        getOnPrimary,
        getWarn,
        getOnWarn,
        theme
    }
}
